module.exports = __webpack_public_path__ + "static/media/For-Anglers-Badge-Only-01 (1).49e4629d.svg";